import { FeedbackBlank, type FeedbackBlankProps } from '../FeedbackBlank';

export function enhanceFeedbackBlank<T extends Partial<FeedbackBlankProps>>(predefinedProps: T) {
    return function FeedbackBlankEnhanced(props: Omit<FeedbackBlankProps, keyof T>) {
        return <FeedbackBlank {...props} {...predefinedProps} />;
    };
}
